import { createClient, type Session, type SupabaseClient } from '@supabase/supabase-js';

const URL = import.meta.env.VITE_SUPABASE_URL?.trim() ?? '';
const KEY = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() ?? '';

export const isSupabaseConfigured = Boolean(URL && KEY);

if (!isSupabaseConfigured) {
  console.error(
    '[admin] Faltam VITE_SUPABASE_URL ou VITE_SUPABASE_ANON_KEY.\n' +
      '  cp apps/admin/.env.example apps/admin/.env\n' +
      '  ou use o switch central em .env.local na raiz do repo e reinicie npm run dev',
  );
}

export const supabase: SupabaseClient = isSupabaseConfigured
  ? createClient(URL, KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce',
      },
    })
  : createClient('https://placeholder.supabase.co', 'placeholder-key-not-used', {
      auth: {
        persistSession: false,
        autoRefreshToken: false,
        detectSessionInUrl: false,
      },
    });

export type { Session };
